exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "scoring-display .ui-datatable .ui-datatable-thead > tr th {\n  padding: 2px; }\n\nscoring-display .flight-monitor-column {\n  text-align: center;\n  color: #2196F3;\n  font-weight: bold; }\n  scoring-display .flight-monitor-column .submitted {\n    color: darkgreen;\n    font-weight: bold; }\n  scoring-display .flight-monitor-column .withdrawn {\n    color: darkred;\n    font-weight: bold; }\n\nscoring-display .noheader-grid .ui-datagrid-header {\n  display: none; }\n\nscoring-display .ui-lg-6 {\n  padding: 2px; }\n\nscoring-display .battery-level {\n  font-weight: bold; }\n  scoring-display .battery-level.battery-ok {\n    color: green; }\n  scoring-display .battery-level.battery-low {\n    color: #c67605; }\n  scoring-display .battery-level.battery-critical {\n    color: #ff1010; }\n\nscoring-display .blink {\n  text-decoration: blink;\n  -webkit-animation-name: blinker;\n  -webkit-animation-duration: 0.6s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: ease-in-out;\n  -webkit-animation-direction: alternate; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/scoring-display/scoring-display.component.scss
// module id = ../../../../../src/app/component-module/scoring-display/scoring-display.component.scss
// module chunks = main